var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.55307 2.57579L11.3046 7.34149L13.8612 5.25049C13.5568 5.01119 13.3595 4.64109 13.3554 4.22379C13.3479 3.49369 13.9342 2.89559 14.6642 2.88829C15.3944 2.88089 15.9925 3.4671 15.9997 4.1972C16.007 4.9274 15.4211 5.52529 14.6908 5.53279C14.6321 5.53329 14.5742 5.53009 14.5174 5.52319L13.442 10.3685C13.3762 10.6648 13.1207 10.8697 12.8174 10.8697H12.2332H9.21617H6.99067H4.08667H3.38947C3.08617 10.8697 2.83067 10.6648 2.76487 10.3685L1.67707 5.46699C1.56827 5.49729 1.45397 5.51399 1.33567 5.51519C0.605566 5.52249 0.00746564 4.93639 6.56435e-05 4.2063C-0.00713436 3.4762 0.578866 2.87799 1.30907 2.87079C2.03927 2.86349 2.63737 3.44959 2.64447 4.17969C2.64837 4.56359 2.48807 4.91099 2.22897 5.15519L4.97906 7.40439L7.75797 2.59119C7.21447 2.43137 6.81497 1.93153 6.80897 1.33571C6.80167 0.605594 7.38777 0.00748491 8.11797 6.49091e-05C8.84807 -0.00709509 9.44617 0.579005 9.45347 1.30912C9.45937 1.89643 9.08127 2.39803 8.55307 2.57579ZM3.54877 11.5961H12.6919C13.0694 11.5961 13.3774 11.9041 13.3774 12.2816C13.3774 12.6592 13.0694 12.9675 12.6919 12.9675H3.54877C3.17117 12.9675 2.86317 12.6595 2.86317 12.2819C2.86317 11.9044 3.17117 11.5961 3.54877 11.5961Z",
    fill: "#FFC700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownIcon);
export default __webpack_public_path__ + "static/media/crown_icon.3fbda2c34958779f6b152867061e48ad.svg";
export { ForwardRef as ReactComponent };